const POLL_INTERVAL = 60000

// Статус стріму (онлайн/офлайн + кількість глядачів) через наш серверний
// прокси /api/twitchStream — Helix API вимагає app access token, який не
// можна світити на клієнті
export const useTwitchStreamStatus = () => {
  const isLive = useState('twitchStreamLive', () => false)
  const viewerCount = useState('twitchStreamViewers', () => 0)
  const streamTitle = useState('twitchStreamTitle', () => '')
  // ISO-час старту ефіру — сторінка /live показує з нього тривалість стріму
  const startedAt = useState('twitchStreamStartedAt', () => null)

  if (import.meta.client) {
    const fetchStatus = async () => {
      try {
        const res = await $fetch('/api/twitchStream')
        isLive.value = !!res.live
        viewerCount.value = res.viewerCount || 0
        streamTitle.value = res.title || ''
        startedAt.value = res.startedAt || null
      } catch (e) {
        // Статус стріму не критичний функціонал - мовчки ігноруємо збої
      }
    }

    let timer = null

    onMounted(() => {
      fetchStatus()
      timer = setInterval(fetchStatus, POLL_INTERVAL)
    })

    onBeforeUnmount(() => {
      if (timer) clearInterval(timer)
    })
  }

  return { isLive, viewerCount, streamTitle, startedAt }
}
